import { Platform } from "react-native";
export const importBillDeskSdk = () => {
    if (Platform.OS === 'web') {
        const script1 = document.createElement('script');
        script1.src = 'https://uat.billdesk.com/jssdk/v1/dist/billdesksdk/billdesksdk.esm.js';
        script1.type = 'module';
        document.head.appendChild(script1);
        const script2 = document.createElement('script');
        script2.src = 'https://uat.billdesk.com/jssdk/v1/dist/billdesksdk.js';
        script2.setAttribute('nomodule', '');
        document.head.appendChild(script2);
        const stylesheetLink = document.createElement('link');
        stylesheetLink.href = 'https://uat.billdesk.com/jssdk/v1/dist/billdesksdk/billdesksdk.css';
        stylesheetLink.rel = 'stylesheet';
        document.head.appendChild(stylesheetLink);
    }
};
